export type SubscriptionEventPayloadKind = 'purchase' | 'behavioral'

export interface SubscriptionEventLogTemplate {
  id: string
  label: string
  graphqlEventName: string
  payloadKind: SubscriptionEventPayloadKind
}

export const SUBSCRIPTION_EVENT_LOG_TEMPLATES: SubscriptionEventLogTemplate[] = [
  {
    id: 'subscription_signup',
    label: 'Subscription signup',
    graphqlEventName: 'SubscriptionSignup',
    payloadKind: 'purchase',
  },
  {
    id: 'subscription_renewed',
    label: 'Subscription renewed',
    graphqlEventName: 'SubscriptionRenewed',
    payloadKind: 'purchase',
  },
  {
    id: 'plan_changed',
    label: 'Plan changed',
    graphqlEventName: 'PlanChanged',
    payloadKind: 'purchase',
  },
  {
    id: 'refund_completed',
    label: 'Refund completed',
    graphqlEventName: 'RefundCompleted',
    payloadKind: 'purchase',
  },
  {
    id: 'subscription_canceled',
    label: 'Subscription canceled',
    graphqlEventName: 'SubscriptionCanceled',
    payloadKind: 'behavioral',
  },
  {
    id: 'subscription_paused',
    label: 'Subscription paused',
    graphqlEventName: 'SubscriptionPaused',
    payloadKind: 'behavioral',
  },
  {
    id: 'subscription_resumed',
    label: 'Subscription resumed',
    graphqlEventName: 'SubscriptionResumed',
    payloadKind: 'behavioral',
  },
  {
    id: 'refund_requested',
    label: 'Refund requested',
    graphqlEventName: 'RefundRequested',
    payloadKind: 'behavioral',
  },
  {
    id: 'subscription_comped',
    label: 'Subscription comped',
    graphqlEventName: 'SubscriptionComped',
    payloadKind: 'behavioral',
  },
  {
    id: 'payment_failed',
    label: 'Payment failed',
    graphqlEventName: 'PaymentFailed',
    payloadKind: 'behavioral',
  },
]

export function getDefaultSubscriptionEventId (): string {
  return SUBSCRIPTION_EVENT_LOG_TEMPLATES[0].id
}

export function getSubscriptionEventTemplate (id: string): SubscriptionEventLogTemplate | undefined {
  return SUBSCRIPTION_EVENT_LOG_TEMPLATES.find((t) => t.id === id)
}

const SUBSCRIPTION_PURCHASE_SEND_HINT =
  'Records a purchase-style event in Braze. Price, currency, and product SKU are required for a valid test.'

const SUBSCRIPTION_BEHAVIORAL_SEND_HINT =
  'Records a subscription lifecycle event in Braze. Profile fields may update with the send.'

/** Plain-language guidance for the billing event info tooltip (Admin QA). */
export function getSubscriptionEventSendHint (subscriptionEventId: string): string {
  const template = getSubscriptionEventTemplate(subscriptionEventId)
  if (!template) {
    return SUBSCRIPTION_BEHAVIORAL_SEND_HINT
  }
  return template.payloadKind === 'purchase'
    ? SUBSCRIPTION_PURCHASE_SEND_HINT
    : SUBSCRIPTION_BEHAVIORAL_SEND_HINT
}
